import React from 'react';
import { Button } from 'src/components/Button';
import { WorkerActionsButtonProps } from './types';
import { Typography } from '@mui/material';
import { TYPOGRAPHY_WEIGHT, TYPOGRAPHY_COLORS } from '../Typography/types';

export const WorkerActionsButton: React.FC<WorkerActionsButtonProps> = ({
  label,
  variant,
  color,
  onClick,
  disabled = false,
}) => (
  <Button
    variant={variant}
    color={color}
    onClick={onClick}
    disabled={disabled}
    sx={{ width: '50%' }}>
    <Typography
      variant="button"
      sx={{ fontSize: { xxl: 12, xl: 10, lg: 9, xs: 9 } }}
      fontWeight={TYPOGRAPHY_WEIGHT.MEDIUM}
      color={TYPOGRAPHY_COLORS.WHITE}>
      {label}
    </Typography>
  </Button>
);
